/* eslint-disable import/no-anonymous-default-export */
export default (stats = [], action) => {
  switch (action.type) {
    case "MONTH_STATS":
      return action.payload;

    default:
      return stats;
  }
};
